export default function Accordion () {
    let accordionExists = document.getElementsByClassName('accordion').length;

    const accordionItems = document.querySelectorAll('.accordion-item');
    const accordionHeaders = document.querySelectorAll('.accordion-item__header');

    const fn = {
        init: function () {
            accordionHeaders.forEach(accordionHeader => {
                accordionHeader.addEventListener('click', function handleClick(event) {
                    if (accordionHeader.parentElement.classList.contains('accordion-open')){
                        accordionHeader.parentElement.classList.remove('accordion-open');
                    } else {
                        accordionItems.forEach(accordionItem => {accordionItem.classList.remove('accordion-open')});
                        accordionHeader.parentElement.classList.add('accordion-open');
                    }
                });
            });
        }
    };

    if (accordionExists) {
        fn.init();   
    }
}